import styled from 'styled-components'

export const GamePlayArea = styled.div`
  height: 65vh;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  position: relative;
  flex-direction: column;
  margin: 0px 0 0 0;
  padding: 0 20px;
`

export const GamePlayStats = styled.div`
  height: 35vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  position: inherit;
  z-index: 1;
`
